export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7223.355a4218.jpg";